export default __webpack_public_path__ + "604f0132fd5639cd3ae3a16930917af5.woff2";